import type { PullRequestEditInput, PullRequestEditResult } from "@afar-research/contracts";
import { createStore } from "zustand/vanilla";

export function createPullRequestEditSession() {
  return createStore<{
    draft: PullRequestEditInput | null;
    command: PullRequestEditInput | null;
    pending: boolean;
    result: PullRequestEditResult | null;
  }>(() => ({ draft: null, command: null, pending: false, result: null }));
}
export type PullRequestEditSession = ReturnType<typeof createPullRequestEditSession>;
